import { io, Socket } from "socket.io-client";
import { getProdBaseURL } from "./APIHelpers";
import { get, set } from "lockr";
import { Dispatch } from "react";
import { updateOrderStatus } from "../redux/slices/Items";
import { DemoState, setCloningProgress } from "../redux/slices/Demo";
import { v4 as mtIdGenerate } from "uuid";

export function getOrCreateMtId(): string {
  let mtId = get("mtId");
  if (!mtId) {
    mtId = mtIdGenerate();
    set("mtId", mtId);
  }
  return mtId;
}

export const initiateSocketIo = (dispatch: Dispatch<any>) => {
  let url = "http://localhost:3500";
  if (process.env.NODE_ENV === "production") {
    let prodURL = getProdBaseURL();
    url = prodURL.replace(/\/api\/$/, "");
  }

  if (url) {
    const socket = io(url, {
      query: {
        clientType: "customer",
        customerId: getOrCreateMtId(),
      },
    });
    if (window && socket) {
      window.socket = socket;
    }

    socket.once("connect", () => {
      handleSocketEvents(socket, dispatch);
    });
  }
};

export const handleSocketEvents = (socket: Socket, dispatch: Dispatch<any>) => {
  socket.on("orderUpdate", (data: { orderNumber: number; status: number }) => {
    dispatch(updateOrderStatus(data));
  });

  socket.on("connect", () => {
    console.log("Connected to socket server.");
  });

  socket.on("disconnect", () => {
    console.log("Disconnected from socket server.");
  });

  socket.on("connect_error", (err) => {
    console.error("Socket connection error:", err.message);
  });

  socket.on(
    "cloneProgressUpdate",
    ({ message, step, totalSteps }: DemoState) => {
      dispatch(setCloningProgress({ message, step, totalSteps }));
    }
  );
};

export const cleanUpListeners = (socket: Socket) => {
  socket.off("connect");
  socket.off("disconnect");
  socket.off("connect_error");
  socket.off("orderUpdate");
  socket.off("cloneProgressUpdate");
  socket.disconnect();
};
